<template>
  <div id="adminNewsletterCampaign">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ newsletter }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Gruppi</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
        <h1>Gruppi 
          <span style="float:right;" v-if="spanRowSelected != ''">
                    <b>{{ spanRowSelected }}</b>
                  </span></h1>
    </div>
    <div class="container-fluid">
      <div class="card">
       <!-- <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabAdminNewsletterCampaign" role="tabpanel">
            <div class="card-body card-body-table" style="padding:0px !important;">
              <!-- <div class="row">
                <div class="col-sm-12">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabAdminNewsletterCampaign"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabAdminNewsletterCampaignList"
                        role="tab"
                        aria-controls="tabAdminNewsletterCampaignList"
                      >
                        <i class="fa fa-users"></i>
                        <span>Gruppi</span>
                      </button>
                    </li>
                   <li class="nav-item">
                      <button
                        id="tabAdminNewsletterClienti"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminNewsletterCustomerList"
                        role="tab"
                        aria-controls="tabAdminNewsletterCustomerList"
                        :disabled="disableTab"
                        v-on:click="onTabCustomer"
                      >
                        <i class="fa fa-briefcase"></i>
                        <span>Utenti</span>
                      </button>
                    </li>
                    <li class="nav-item">
                      <button
                        id="tabAdminNewsletterContact"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminNewsletterContactList"
                        role="tab"
                        aria-controls="tabAdminNewsletterContactList"
                        v-on:click="onTabContact"
                        :disabled="disableTab"
                      >
                        <i class="fa fa-address-card"></i>
                        <span>Contatti</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div> --->
                <div class="tab-pane nopadding active" id="" role="tabpanel">
                  <div class="tab-content noborder">
                    <div class="tab-pane active" id="tabAdminNewsletterListCampaign" role="tabpanel">
                      <div class="row align-btns">
                        <div class="col-12 text-left">
                          <button
                            id="btnAddCampaign"
                            type="button"
                            class="btn btn-primary"
                            @click="addCampaign"
                          >
                            <i class="fa fa-plus"></i>
                            <span>{{ add }}</span>
                          </button>
                          <button
                            id="btnSaveCampaign"
                            type="button"
                            class="btn btn-success"
                            @click="confirmSaveCampaign"
                            :disabled="disableButton"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>{{ save }}</span>
                          </button>
                          <button
                            id="btnDeleteCampaign"
                            type="button"
                            class="btn btn-danger"
                            @click="confirmDeleteCampaign"
                            :disabled="disableButton"
                          >
                            <i class="fa fa-trash"></i>
                            <span>{{ del }}</span>
                          </button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <bootstrapTable
                            :configurations="tableListConfiguration"
                            :datas="tableData"
                            id="tableAdminNewsletterCampaignList"
                            :onCheck="onTableListCheck"
                            :onCheckAll="onTableListCheck"
                            :onUncheck="onTableListCheck"
                            :onUncheckAll="onTableListCheck"
                            ref="tableAdminNewsletterCampaignList"
                            :results="tableResult"
                          ></bootstrapTable>
                        </div>
                      </div>
                    </div>

            <div class="tab-pane" id="tabBodyMenuTab" role="tabpanel" style="box-shadow:none!important;padding:0px!important;">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <button
                        id="tabAdminGroup"
                        class="nav-link active"
                        type="button"
                        data-toggle="tab"
                        href="#tabAdminGroup"
                        role="tab"
                        aria-controls="tabAdminGroup"
                        v-on:click="ontabAdminGroup"  
                      >
                        <i class=""></i>
                        <span>Info</span>
                      </button>
                    </li>
                    <li class="nav-item" v-if="rowIdSelected>0">
                      <button
                        id="tabAdminUser"
                        type="button"
                        class="nav-link"
                        data-toggle="tab"
                        href="#tabAdminUser"
                        role="tab"
                        aria-controls="tabAdminUser"  
                        v-on:click="ontabAdminUser"          
                      >
                        <i class=""></i>
                        <span>Utenti</span>
                      </button>
                    </li>
                      <li class="nav-item" v-if="rowIdSelected>0">
                    <button
                      id="tabAdminContacts"
                      class="nav-link"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminContacts"
                      role="tab"
                      aria-controls="tabAdminContacts"
                      v-on:click="ontabAdminContacts"
                    >
                      <span>Contatti</span>
                    </button>
                  </li>
                </ul>
</div>  <!-- close menu tab ---> 
                  <!--detail gruppi --->
                  <div class="tab-content noborder">
                    <div class="tab-pane active" id="tabAdminNewsletterCampaignDetail" role="tabpanel" style="box-shadow: none;">
                      <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                      <pageDetail
                        functions="AdminNewsletterCampaign"
                        :configurations="detailConfiguration"
                        :jsonValue="detailData"
                      ></pageDetail>
                      <div class="row">
                        <div class="col-lg-12 text-right">
                          <button
                            id="btnCancelNew"
                            type="button"
                            class="btn btn-danger"
                            @click="cancelNewCampaign"
                          >
                            <i class="fa fa-times"></i>
                            <span>{{ cancel }}</span>
                          </button>
                          <button
                            id="btnAddNew"
                            type="button"
                            class="btn btn-success"
                            @click="confirmSaveNewCustomer()"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>{{ save }}</span>
                          </button>
                        </div>
                      </div>
                  </div>
                </div> 
              <!-- end detail gruppi --->  
              
                <!--detail utenti --->
              <div class="tab-content noborder">
                <div class="tab-pane" id="tabAdminNewsletterCampaignDetailUser" role="tabpanel" style="text-align: left;box-shadow: none;">
                   <div class="row">
                        <div class="col-sm-12">
                          <bootstrapTable
                            :configurations="TableUserConfiguration"
                            :datas="tableDataUsers"
                            id="tableAdminNewsletterGroupUser"                   
                            ref="tableAdminNewsletterGroupUser"
                            :results="tableResult"
                          ></bootstrapTable>
                          <div class="row">
                        <div class="col-lg-12 text-right">
                          <button
                            id="btnCancelNew"
                            type="button"
                            class="btn btn-success"
                            @click="cancelNewCampaign"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>Salva</span>
                          </button>
                        </div>
                      </div>
                    </div>
                      </div>   
                </div></div> 
                 <!--  <div class="tab-content noborder">
                    <div class="tab-pane" id="tabAdminNewsletterCampaignDetailUser" role="tabpanel" style="text-align: left;box-shadow: none;">--->
                         <!--Ricerca per Ragione Sociale,Nome,Cognome,N.Telefono ---> 
                      <!--<div class="row" style="font-size: 16px; padding:10px;"> 
                        <div class="col-1">
                          <label></label>
                          </div> 
                           <div class="col-3">
                          <label>Ragione Sociale</label>
                          <input type="text" id="business_name" name="business_name" class="form-control" placeholder="Ragione Sociale"/>
                          </div> 
                           <div class="col-3">
                          <label>Nome e Cognome</label>
                           <input type="text" id="name" name="name" class="form-control" placeholder="Nome e Cognome"/>
                          </div> 
                           <div class="col-3">
                          <label>Telefono</label>
                           <input type="text" id="telephone_number" name="telephone_number" class="form-control" placeholder="Telefono"/>
                          </div> 
                          <div class="col-2">
                           <button
                            id="btnSearch"
                            type="button"
                            class="btn btn-link"
                            @click="onInputSearchUser"
                          ><i class="fa fa-search"></i>
                            <span>Cerca Utente</span>
                          </button>            
                        </div></div>--->
                    <!--END Ricerca per Ragione Sociale,Nome,Cognome,N.Telefono --->  
                    <!--<div
                      v-for="tableDataUser in tableDataUsers"
                      v-bind:key="tableDataUser.user_id"
                    >
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                        <div class="row">                
                          <div class="col-1">
                            <div class="form-check">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; vertical-align: bottom"
                              >
                                 <input v-if="tableDataUser.check"
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                  checked="checked"
                                  :id="'check' + tableDataUser.user_id"
                                  :data-id-related="tableDataUser.user_id"
                                  @change="onChangeUser(tableDataUser.user_id)"/>
                                   <input v-else
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                  :id="'check' + tableDataUser.user_id"
                                  :data-id-related="tableDataUser.user_id"
                                  @change="onChangeUser(tableDataUser.user_id)"/>                            
                                <div class="switch-slider"></div>
                              </label>
                            </div>
                          </div>
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataUser.business_name"> {{ tableDataUser.business_name }}</span>
                          </div> 
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataUser.name"> {{ tableDataUser.name }} {{ tableDataUser.surname }}</span>
                          </div> 
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataUser.telephone_number">{{ tableDataUser.telephone_number }}</span>
                          </div> 
                        </div>
                      </div></div> 
                      <hr style="border-top: 1px solid rgba(240, 240, 240, 1);    margin-top: 0rem; margin-bottom: 15px;">  
                  </div>
                       <div class="row">
                        <div class="col-lg-12 text-right">
                          <button
                            id="btnCancelNew"
                            type="button"
                            class="btn btn-danger"
                            @click="cancelNewCampaign"
                          >
                            <i class="fa fa-times"></i>
                            <span>{{ cancel }}</span>
                          </button>                       
                        </div>
                      </div>  
                </div>
            </div> ---> 
              <!-- end detail utenti --->  

              <!--detail contatti --->
              <div class="tab-content noborder">
                    <div class="tab-pane" id="tabAdminNewsletterCampaignDetailContacts" role="tabpanel" style="text-align: left;box-shadow: none;">
                      <div class="row">
                        <div class="col-sm-12">
                          <bootstrapTable
                            :configurations="TableContactConfiguration"
                            :datas="tableDataContact"
                            id="tableAdminNewsletterGroupContact"                   
                            ref="tableAdminNewsletterGroupContact"
                            :results="tableResult"
                          ></bootstrapTable>
                           <div class="row">
                        <div class="col-lg-12 text-right">
                          <button
                            id="btnCancelNew"
                            type="button"
                            class="btn btn-success"
                            @click="cancelNewCampaign"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>Salva</span>
                          </button>
                        </div>
                      </div>
                        </div>
                      </div>   
                </div></div>
                <!-- end detail contatti --->

                <!--detail contatti --->
                 <!-- <div class="tab-content noborder">
                    <div class="tab-pane" id="tabAdminNewsletterCampaignDetailContacts" role="tabpanel" style="text-align: left;box-shadow: none;">
                      <div class="row" style="font-size: 16px; padding:10px;"> 
                        <div class="col-1">
                          <label></label>
                          </div> 
                           <div class="col-3">
                          <label>Ragione Sociale</label>
                          <input type="text" id="business_name" name="business_name" class="form-control"/>
                          </div> 
                          <div class="col-3">
                          <label>Nome</label>
                           <input type="text" id="name" name="name" class="form-control"/>
                          </div> 
                           <div class="col-3">
                          <label>Telefono</label>
                           <input type="text" id="telephone_number" name="telephone_number" class="form-control"/>
                          </div> 
                          <div class="col-2">
                           <button
                            id="btnSearch"
                            type="button"
                            class="btn btn-link"
                            @click="onInputSearchContact"
                          ><i class="fa fa-search"></i>
                            <span>Cerca Contatto</span>
                          </button>            
                        </div></div>
                    result --->
                    <!--<div
                      v-for="tableDataContact in tableDataContact"
                      v-bind:key="tableDataContact.id"
                    >

                <div class="row">
                  <div class="col-sm-12 col-md-12">
                        <div class="row">                
                          <div class="col-1">
                            <div class="form-check">
                              <label
                                class="switch switch-pill switch-primary"
                                style="margin: 2px; vertical-align: bottom"
                              >
                                <input v-if="tableDataContact.check"
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                   :id="'check' + tableDataContact.id"
                                  :data-id-related="tableDataContact.id"
                                  @change="onChangeContact(tableDataContact.id)"
                                />
                                  <input v-else
                                  type="checkbox"
                                  name="check"
                                  class="switch-input checkbox"
                                   :id="'check' + tableDataContact.id"
                                  :data-id-related="tableDataContact.id"
                                  @change="onChangeContact(tableDataContact.id)"
                                />  
                                <div class="switch-slider"></div>
                              </label>
                            </div>
                          </div>
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataContact.business_name"> {{ tableDataContact.business_name }}</span>
                          </div> 
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataContact.name"> {{ tableDataContact.name }} {{ tableDataContact.surname }}</span>
                          </div> 
                            <div class="col-3">
                            <span class="col- col-form-label nopadding"
                            :for="tableDataContact.telephone_number">{{ tableDataContact.telephone_number }}</span>
                          </div> 
                        </div>
                      </div></div>  
                      <hr style="border-top: 1px solid rgba(240, 240, 240, 1);    margin-top: 0rem; margin-bottom: 15px;">   
                  </div>
                       <div class="row">
                        <div class="col-lg-12 text-right">
                          <button
                            id="btnCancelNew"
                            type="button"
                            class="btn btn-danger"
                            @click="cancelNewCampaign"
                          >
                            <i class="fa fa-times"></i>
                            <span>{{ cancel }}</span>
                          </button>                       
                        </div>--->
                      <!-- </div>end result --->
                      
                <!-- </div></div> ---> 
              <!-- end detail contatti --->  
            </div>
          </div>
               <!-- <div class="tab-pane" id="tabAdminNewsletterCustomerList" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableCustomerEnabledConfiguration"
                        :datas="tableCustomerEnabledData"
                        :onCheck="onTableCustomerEnabledCheck"
                        :onCheckAll="onTableCustomerEnabledCheck"
                        :onUncheck="onTableCustomerEnabledCheck"
                        :onUncheckAll="onTableCustomerEnabledCheck"
                        id="tableCustomerEnabled"
                        ref="tableCustomerEnabled"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            @click="addCustomerToGroup"
                            :disabled="disableAddCustomerButton"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            @click="removeCustomerToGroup"
                            :disabled="disableRemoveCustomerButton"
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableCustomerDisabledConfiguration"
                        :datas="tableCustomerDisabledData"
                        :onCheck="onTableCustomerDisabledCheck"
                        :onCheckAll="onTableCustomerDisabledCheck"
                        :onUncheck="onTableCustomerDisabledCheck"
                        :onUncheckAll="onTableCustomerDisabledCheck"
                        id="tableCustomerDisabled"
                        ref="tableCustomerDisabled"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="tabAdminNewsletterContactList" role="tabpanel">
                  <div class="row">
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableContactEnabledConfiguration"
                        :datas="tableContactEnabledData"
                        :onCheck="onTableContactEnabledCheck"
                        :onCheckAll="onTableContactEnabledCheck"
                        :onUncheck="onTableContactEnabledCheck"
                        :onUncheckAll="onTableContactEnabledCheck"
                        id="tableContactEnabled"
                        ref="tableContactEnabled"
                      ></bootstrapTable>
                    </div>
                    <div class="col-sm-2 vertical-center">
                      <div class="container-fluid">
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-primary"
                            :disabled="disableAddContactButton"
                            @click="addContactToGroup"
                          >
                            <i class="fa fa-arrow-left"></i>
                            <span>{{ add }}</span>
                          </button>
                        </div>
                        <div class="row">&nbsp;</div>
                        <div class="row">
                          <button
                            type="button"
                            class="btn btn-block btn-secondary"
                            :disabled="disableRemoveContactButton"
                            @click="removeContactToGroup"
                          >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ remove }}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <bootstrapTable
                        addInput="false"
                        :configurations="tableContactDisabledConfiguration"
                        :datas="tableContactDisabledData"
                        :onCheck="onTableContactDisabledCheck"
                        :onCheckAll="onTableContactDisabledCheck"
                        :onUncheck="onTableContactDisabledCheck"
                        :onUncheckAll="onTableContactDisabledCheck"
                        id="tableContactDisabled"
                        ref="tableContactDisabled"
                      ></bootstrapTable>
                    </div>
                  </div>
                </div> -->
           
            </div>
          </div>
        </div>

</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";

export default {
  name: "adminNewsletterCampaign",
  components: {
    BootstrapTable,
    PageDetail
  },
  data() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      campaign: dictionaryHelpers.getDictionary("Campaign"),
      campaigns: dictionaryHelpers.getDictionary("Campaigns"),
      del: dictionaryHelpers.getDictionary("Delete"),
      remove: dictionaryHelpers.getDictionary("Remove"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      detailConfiguration: [],
      rowsSelected: 0,
      rowIdSelected: 0,
      tableDataUsers: [],
      tableDataContact: [],
      detailData: {},
      disableButton: true,
      disableTab: true,
      disableAddContactButton: true,
      disableRemoveContactButton: true,
      disableAddCustomerButton: true,
      disableRemoveCustomerButton: true,
      newsletter: dictionaryHelpers.getDictionary("Newsletter"),
      save: dictionaryHelpers.getDictionary("Save"),
      spanRowSelected: "",
      tableListConfiguration: [],
      TableContactConfiguration: [],
      TableUserConfiguration: [],
      tableData: [],
      tableResult: [],
      tableCustomerEnabledConfiguration: [],
      tableCustomerEnabledData: [],
      tableCustomerDisabledConfiguration: [],
      tableCustomerDisabledData: [],
      tableContactEnabledConfiguration: [],
      tableContactEnabledData: [],
      tableContactDisabledConfiguration: [],
      tableContactDisabledData: [],
      url: window.location.pathname
    };
  },
  created() {
    var adminNewsletterCampaign = this;

    adminConfigurationServices.getFunctionality(function(result) {
      
      $.each(result.data.tablesConfigurations, function(i, tableConfiguration) {
        if (tableConfiguration.code == "Table") {
          adminNewsletterCampaign.tableListConfiguration = tableConfiguration.tablesConfigurations;
        }
         if (tableConfiguration.code == "TableContact") {
          adminNewsletterCampaign.TableContactConfiguration = tableConfiguration.tablesConfigurations;
         }
          if (tableConfiguration.code == "TableUser") {
          adminNewsletterCampaign.TableUserConfiguration = tableConfiguration.tablesConfigurations;
          }
      });
      $.each(result.data.tabsConfigurations, function(i, tabConfiguration) {
        if (tabConfiguration.code == "Detail") {
          adminNewsletterCampaign.detailConfiguration = tabConfiguration.pageConfigurations;
        }
      });

      adminNewsletterCampaign.loadTable();
    });
  },
  mounted() {
    this.tableCustomerEnabledConfiguration = [
      { inputType: "TableCheckbox", visibleOnTable: true },
      { field: "name", title: "Nome", visibleOnTable: true },
      { field: "surname", title: "Cognome", visibleOnTable: true },
      { field: "email", title: "Email", visibleOnTable: true }
    ];
    this.tableCustomerDisabledConfiguration = [
      { inputType: "TableCheckbox", visibleOnTable: true },
      { field: "name", title: "Nome", visibleOnTable: true },
      { field: "surname", title: "Cognome", visibleOnTable: true },
      { field: "email", title: "Email", visibleOnTable: true }
    ];

    this.tableContactEnabledConfiguration = [
      { inputType: "TableCheckbox", visibleOnTable: true },
      { field: "name", title: "Nome", visibleOnTable: true },
      { field: "surname", title: "Cognome", visibleOnTable: true },
      { field: "email", title: "Email", visibleOnTable: true }
    ];
    this.tableContactDisabledConfiguration = [
      { inputType: "TableCheckbox", visibleOnTable: true },
      { field: "name", title: "Nome", visibleOnTable: true },
      { field: "surname", title: "Cognome", visibleOnTable: true },
      { field: "email", title: "Email", visibleOnTable: true }
    ];
  },
  methods: {
    loadTable() {
      var adminCrmCustomer = this;

      groupNewsletterServices.getAll(function(result) {
        adminCrmCustomer.tableData = result.data;
        $("#tabBodyMenuTab").removeClass("active");
        $("#tabAdminNewsletterCampaignDetail").removeClass("active");
        spinnerHelpers.hide();
      });
    },
    addCampaign: function() {
      this.detailData = {};
      this.rowIdSelected = 0;
      $("#tabAdminNewsletterCampaignDetail").addClass("active");
      $("#tabAdminNewsletterListCampaign").removeClass("active");
    },

    onTableListCheck: function() {
      var countRowSelected = this.$refs.tableAdminNewsletterCampaignList.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
        this.disableTab = true;
      } else {
        if (countRowSelected == 1) {
          this.disableTab = false;
        } else {
          this.disableTab = true;
        }
        this.disableButton = false;
      }
    },

    ontabAdminGroup() {    
        $("#tabAdminNewsletterCampaignDetail").addClass("active");
        $("#tabAdminNewsletterCampaignDetailUser").removeClass("active");
        $("#tabAdminNewsletterCampaignDetailContacts").removeClass("active"); 
      spinnerHelpers.hide();
    },
    ontabAdminUser() {  
     var adminNewsletterCampaign = this;    
        $("#tabAdminNewsletterCampaignDetailUser").addClass("active");
        $("#tabAdminNewsletterCampaignDetail").removeClass("active");
        $("#tabAdminNewsletterCampaignDetailContacts").removeClass("active"); 
     
        data = {
        sUserId: storageData.sUserId(),
        rowSelected: this.rowIdSelected,
      };
     
        groupNewsletterServices.getAllByUser(data, function(result) { 
        adminNewsletterCampaign.tableDataUsers = result.data;
        spinnerHelpers.hide();
      });
    },

    ontabAdminContacts() { 
      var adminNewsletterCampaign = this;     
        $("#tabAdminNewsletterCampaignDetailContacts").addClass("active");
        $("#tabAdminNewsletterCampaignDetail").removeClass("active");
        $("#tabAdminNewsletterCampaignDetailUser").removeClass("active"); 

        data = {
        sUserId: storageData.sUserId(),
        rowSelected: this.rowIdSelected,
      };
     
        groupNewsletterServices.getAllByContact(data, function(result) {  
        adminNewsletterCampaign.tableDataContact = result.data;
        spinnerHelpers.hide();
      }); 
    },

     onChangeUser(IdCustomer) {
      var adminNewsletterCampaign = this;  
      if ($("#check" + IdCustomer).is(":checked")) {
        var data = {
          IdCustomer: IdCustomer,
          group_newsletter_id: this.rowIdSelected,
        };
      /* insert */
      groupNewsletterServices.insertUser(data, function(result) {  
        notificationHelpers.success(adminNewsletterCampaign.insertCompleted); 
      }); 
      } else {
        /* delete */
       groupNewsletterServices.delUser(IdCustomer, adminNewsletterCampaign.rowIdSelected, function (result) {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted")); 
      });
      }
    },

    onChangeContact (IdContact) {
      var adminNewsletterCampaign = this; 
      if ($("#check" + IdContact).is(":checked")) {
        var data = {
          IdContact: IdContact,
          group_newsletter_id: this.rowIdSelected,
        };
      /* insert */
      groupNewsletterServices.insertContact(data, function(result) {  
        notificationHelpers.success(adminNewsletterCampaign.insertCompleted); 
      }); 
      } else {
        /* delete */
       groupNewsletterServices.delContact(IdContact, adminNewsletterCampaign.rowIdSelected, function (result) {
          notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted")); 
      });
      }
    },

    onInputSearchUser() {
    spinnerHelpers.show();
    var adminNewsletterCampaign = this;

      var data = {
        business_name: $("#business_name").val(), 
        name: $("#name").val(),
        telephone_number: $("#telephone_number").val(),
      }; 
        groupNewsletterServices.getUserSearch(data, function(result) {  
        adminNewsletterCampaign.tableDataUsers= result.data;
        spinnerHelpers.hide();
      });  
    },

    onInputSearchContact() {
    spinnerHelpers.show();
    var adminNewsletterCampaign = this;

      var data = {
          business_name: $("#business_name").val(), 
          name: $("#name").val(),
          telephone_number: $("#telephone_number").val(),
    };  
  },


    groupNewsletterFormatter(value, row, index, field) {
      var adminNewsletterCampaign = this;
      var html =
        '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminNewsletterCampaign.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
         html +=
        '<button class="btn btn-danger" onclick="adminNewsletterCampaign.__vue__.DeleteCampaign(' +
        row.id +
        ')"><i class="fa fa-trash" title="' +
        this.openDetail +
        '" /></button>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminNewsletterCampaign.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

    CheckOnlineFormatter(value, row, index, field){
     var adminNewsletterCampaign = this;  
      if(row.check){
      var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminNewsletterCampaign.__vue__.onChangeCheckOnlineDeLContact(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }else{
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminNewsletterCampaign.__vue__.onChangeCheckOnlineDetailContact(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },

     onChangeCheckOnlineDetailContact(id) {
      var adminNewsletterCampaign = this;
      var data = {
        IdContact: id,
        group_newsletter_id: this.rowIdSelected,
      };
      groupNewsletterServices.insertContact(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
        adminNewsletterCampaign.ontabAdminContacts();
    },
     onChangeCheckOnlineDeLContact(id) {
      var adminNewsletterCampaign = this;
       groupNewsletterServices.delContact(id, adminNewsletterCampaign.rowIdSelected, function (result) {
        notificationHelpers.success("Cancellazione avvenuta con successo");
      });
        adminNewsletterCampaign.ontabAdminContacts();
    },

    CheckOnlineUserFormatter(value, row, index, field){
     var adminNewsletterCampaign = this;  
      if(row.check1 == true){
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" checked="checked" onclick="adminNewsletterCampaign.__vue__.onChangeCheckOnlineDeLUser(' + row.user_id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }else{
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="form-control" class="switch-input" onclick="adminNewsletterCampaign.__vue__.onChangeCheckOnlineDetailUser(' + row.user_id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },

    DeleteCampaign(id){
      console.log(id);
      var adminNewsletterCampaign = this;
      if (confirm("Sei sicuro di voler eliminare?")) {
        adminNewsletterCampaign.executeDelete(id);
      }
    },

    executeDelete(id) {
      var adminNewsletterCampaign = this;
      spinnerHelpers.show();
      groupNewsletterServices.del(id, function() {
      notificationHelpers.success("Cancellazione avvenuta con successo");
      adminNewsletterCampaign.loadTable();
      window.scrollTo(0, 0);
      });
    },

     onChangeCheckOnlineDetailUser(user_id) {
     var adminNewsletterCampaign = this;
       var data = {
          IdCustomer: user_id,
          group_newsletter_id: this.rowIdSelected,
        };
      groupNewsletterServices.insertUser(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
        adminNewsletterCampaign.ontabAdminUser();
    },
     onChangeCheckOnlineDeLUser(user_id) {
      var adminNewsletterCampaign = this;
       groupNewsletterServices.delUser(user_id, adminNewsletterCampaign.rowIdSelected, function (result) {
        notificationHelpers.success("Cancellazione avvenuta con successo");
      });
        adminNewsletterCampaign.ontabAdminUser();
    },


    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmCustomer = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
        if (adminCrmCustomer.rowIdSelected == row.id) {
          adminCrmCustomer.detailData = row;
        }
      });

      $("#tabBodyMenuTab").addClass("active");
      $("#tabAdminNewsletterListCampaign").removeClass("active");
      $("#tabAdminNewsletterCampaignDetail").addClass("active");
       
      spinnerHelpers.hide();
    },
    confirmSaveCampaign() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveCampaign();
      }
    },
    executeSaveCampaign() {
      spinnerHelpers.show();
      var adminCrmCustomer = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(
        this.$refs.tableAdminNewsletterCampaignList.getRowSelected(),
        function(i, row) {
          var rowToSave = row;
          rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
          adminCrmCustomer.rowsSelected = adminCrmCustomer.rowsSelected + 1;

          groupNewsletterServices.update(
            rowToSave,
            function() {
              adminCrmCustomer.checkAllIsSaved();
              adminCrmCustomer.tableResult.push({
                id: rowToSave.id,
                success: true
              });
              notificationHelpers.success(adminCrmCustomer.updateCompleted);
            },
            function(response) {
              adminCrmCustomer.checkAllIsSaved();
              adminCrmCustomer.tableResult.push({
                id: rowToSave.id,
                success: false,
                message: response
              });
              notificationHelpers.error(response);
            }
          );
        }
      );
    },
    confirmSaveNewCustomer() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewCustomer();
      }
    },

    executeSaveNewCustomer() {
      spinnerHelpers.show();
      var adminCrmCustomer = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.company)) {
        this.detailData.company = false;
      }

      if (!functionHelpers.isValued(this.detailData.sendNewsletter)) {
        this.detailData.sendNewsletter = false;
      }

      if (!functionHelpers.isValued(this.detailData.errorNewsletter)) {
        this.detailData.errorNewsletter = false;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        groupNewsletterServices.update(this.detailData, function(result) {
          adminCrmCustomer.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmCustomer.updateCompleted
          });
          notificationHelpers.success(adminCrmCustomer.updateCompleted);
          adminCrmCustomer.loadTable();
          $("#tabAdminNewsletterListCampaign").addClass("active");
          $("#tabAdminNewsletterCampaignDetail").removeClass("active");
        });
      } else {
        groupNewsletterServices.insert(this.detailData, function(result) {
          adminCrmCustomer.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmCustomer.insertCompleted
          });
          notificationHelpers.success(adminCrmCustomer.insertCompleted);
          adminCrmCustomer.loadTable();
          $("#tabAdminNewsletterListCampaign").addClass("active");
          $("#tabAdminNewsletterCampaignDetail").removeClass("active");
        });
      }
    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable();
      }
    },
    confirmDeleteCampaign() {
       if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDeleteCampaign();
      }
    },
    executeDeleteCampaign() {
      spinnerHelpers.show();
      var adminCrmCustomer = this;
      this.rowsSelected = 0;
      this.tableResult = [];
      $.each(
        this.$refs.tableAdminNewsletterCampaignList.getRowSelected(),
        function(i, row) {
          adminCrmCustomer.rowsSelected = adminCrmCustomer.rowsSelected + 1;
          groupNewsletterServices.del(row.id,
            function() {
              adminCrmCustomer.checkAllIsSaved();
              notificationHelpers.success("Cancellazione Avvenuta con Successo");
            },
            function(response) {
              adminCrmCustomer.checkAllIsSaved();
              adminCrmCustomer.tableResult.push({
                
                id: rowToSave.id,
                success: false,
                message: response
              });
                notificationHelpers.error(response);
            }
          );
        }
      );
    },
    
    cancelNewCampaign: function() {
      this.detailData = {};
      $("#tabBodyMenuTab").removeClass("active");
      $("#tabAdminNewsletterCampaignDetail").removeClass("active");
      $("#tabAdminNewsletterCampaignDetailUser").removeClass("active");
      $("#tabAdminNewsletterCampaignDetailContacts").removeClass("active"); 
      $("#tabAdminNewsletterListCampaign").addClass("active");
    },

    /** CONTACT */
    onTabContact() {
      var adminGroupNewsletter = this;
      spinnerHelpers.show();
      var rowSelected = this.$refs.tableAdminNewsletterCampaignList.getRowSelected()[0];
      this.spanRowSelected = rowSelected.description;
      contactGroupNewsletterServices.getIncludedByContactGroup(
        rowSelected.id,
        function(resultincluded) {
          adminGroupNewsletter.tableContactEnabledData = resultincluded.data;
        }
      );
      contactGroupNewsletterServices.getExcludedByContactGroup(
        rowSelected.id,
        function(resultexcluded) {
          adminGroupNewsletter.tableContactDisabledData = resultexcluded.data;
        }
      );
      spinnerHelpers.hide();
      this.disableAddContactButton = true;
      this.disableRemoveContactButton = true;
    },
    onTableContactDisabledCheck() {
      if (this.$refs.tableContactDisabled.countRowSelected() == 0) {
        this.disableAddContactButton = true;
      } else {
        this.disableAddContactButton = false;
      }
    },
    onTableContactEnabledCheck() {
      if (this.$refs.tableContactEnabled.countRowSelected() == 0) {
        this.disableRemoveContactButton = true;
      } else {
        this.disableRemoveContactButton = false;
      }
    },
    addContactToGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableContactDisabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableContactDisabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          contactGroupNewsletterServices.insert(
            {
              idGroupNewsletter: adminSettingUser.$refs.tableAdminNewsletterCampaignList.getRowSelected()[0]
                .id,
              idContact: row.id
            },
            function(result) {
              adminSettingUser.checkAllContactIsSaved();
              notificationHelpers.success(adminSettingUser.updateCompleted);
            }
          );
        });
      }
    },
    removeContactToGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableContactEnabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableContactEnabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          contactGroupNewsletterServices.del(row.id, function(result) {
            adminSettingUser.checkAllContactIsSaved();
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });
        });
      }
    },
    checkAllContactIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        spinnerHelpers.hide();
        this.onTabContact();
      }
    },
    /** END CONTACT */
    /** CUSTOMER */
    onTabCustomer() {
      var adminGroupNewsletter = this;
      spinnerHelpers.show();
      var rowSelected = this.$refs.tableAdminNewsletterCampaignList.getRowSelected()[0];
      this.spanRowSelected = rowSelected.description;
      customerGroupNewsletterServices.getIncludedByCustomerGroup(
        rowSelected.id,
        function(resultincluded) {
          adminGroupNewsletter.tableCustomerEnabledData = resultincluded.data;
        }
      );
      customerGroupNewsletterServices.getExcludedByCustomerGroup(
        rowSelected.id,
        function(resultexcluded) {
          adminGroupNewsletter.tableCustomerDisabledData = resultexcluded.data;
        }
      );
      spinnerHelpers.hide();
      this.disableAddCustomerButton = true;
      this.disableRemoveCustomerButton = true;
    },
    onTableCustomerDisabledCheck() {
      if (this.$refs.tableCustomerDisabled.countRowSelected() == 0) {
        this.disableAddCustomerButton = true;
      } else {
        this.disableAddCustomerButton = false;
      }
    },
    onTableCustomerEnabledCheck() {
      if (this.$refs.tableCustomerEnabled.countRowSelected() == 0) {
        this.disableRemoveCustomerButton = true;
      } else {
        this.disableRemoveCustomerButton = false;
      }
    },
    addCustomerToGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableCustomerDisabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableCustomerDisabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          customerGroupNewsletterServices.insert(
            {
              idGroupNewsletter: adminSettingUser.$refs.tableAdminNewsletterCampaignList.getRowSelected()[0]
                .id,
              idContact: row.id
            },
            function(result) {
              adminSettingUser.checkAllCustomerIsSaved();
              notificationHelpers.success(adminSettingUser.updateCompleted);
            }
          );
        });
      }
    },
    removeCustomerToGroup() {
      var adminSettingUser = this;
      this.rowsSelected = 0;
      if (this.$refs.tableCustomerEnabled.haveRowSelected(true)) {
        spinnerHelpers.show();
        $.each(this.$refs.tableCustomerEnabled.getRowSelected(), function(
          i,
          row
        ) {
          adminSettingUser.rowsSelected = adminSettingUser.rowsSelected + 1;
          customerGroupNewsletterServices.del(row.id, function(result) {
            adminSettingUser.checkAllCustomerIsSaved();
            notificationHelpers.success(adminSettingUser.updateCompleted);
          });
        });
      }
    },
    checkAllCustomerIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        spinnerHelpers.hide();
        this.onTabCustomer();
      }
    }
    /** END CUSTOMER */
  }
};
</script>
<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
.nav-tabs .nav-item{
  width:33.33%;
}
.nav {
  border: 0px;
}
.nav-tabs .nav-link{
  width:100%;
  border-radius:0;
  color:#fff;
  background:#3c4b64;
  border-bottom:3px solid #f45f00 !important;
  border:0px;
}
.nav-tabs .nav-link.active{
  background:#2A3545 !important;
}

.nav-tabs .nav-link.active span{
  color:#fff;
}

.nav-tabs>.nav-item>.nav-link:not(.active){
  background:#3c4b64  !important;
}
</style>